import { http } from '@/lib/http';

const BASE = '/api/v1/tenancy/me/requests-settings';

export interface RequestsSettings {
  /**
   * Master kill switch for auto-approving customer-initiated requests
   * (returns, exchanges, cancels) against the reason catalog. When
   * false, every request lands in the review queue regardless of
   * `RequestReason.autoApproveFor`.
   */
  autoApproveCustomerRequests: boolean;
}

export type UpdateRequestsSettingsPayload = RequestsSettings;

export const requestsSettingsService = {
  get: () => http.get<RequestsSettings>(BASE),
  update: (payload: UpdateRequestsSettingsPayload) =>
    http.patch<RequestsSettings, UpdateRequestsSettingsPayload>(BASE, payload),
};
